import PropTypes from 'prop-types';

const ButtonModal = ({toggleModal, confirmConfirmation}) => {
  return (
    <>
          <button
              type='button'
              className='w-full w-1/2 inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green text-base font-lg text-white hover:bg-green-bright focus:outline-none focus:ring-2 focus:ring-offset-2 sm:ml-3 text-lg font-bold'
              onClick={() => {
              confirmConfirmation();
              }}
              >
          Yes
          </button>
          <button
            type='button'
            className='mt-3 w-full w-1/2 inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red text-base font-lg text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:mt-0 sm:ml-3 text-lg font-bold'
              onClick={() => {  
              toggleModal();
              }}
          >
          No
          </button>
      </>
  );
}

ButtonModal.propTypes = {
  toggleModal: PropTypes.func,
  confirmConfirmation: PropTypes.func
}

export default ButtonModal;